import { expresion_adm, expresion_civil } from 'components/Admin/Inicio-Admin/Dashboard_Admin';
import { EstadosDesvinculacionValidation, IsOpcionDesvinculacionDirectivo, IsOpcionDesvinculacionUsuario, opcionesSideBar, OPCION_TITULO_PLANIFICACION_VACACIONES, ROL_DIRECTIVO_UNIDAD, ROL_DIRECTOR_TALENTOHUMANO, ROL_USUARIO, useSideBarContext, ROL_NOMINA_TH, ROL_ANALISTA_TH_AP, ROL_ENCARGADO_GPE, ROL_ANALISTA_GPE, ROL_FIRMA_HORAS_EXTRAS, OPCION_TITULO_FIRMA_DOC_PAGO_HE, OPCION_TITULO_MODIFICACION_PRESUPUESTO, OPCION_TITULO_ASIGNACION_PRESUPUESTO } from 'Context/SideBarContext';
import React from 'react'
import { useHistory } from 'react-router';
import { TransitionStatus } from 'react-transition-group';
import { Icono_Flecha_Regreso, UserData } from './Sidebar_Principal';
import Sidebar_Principal_Row from './Sidebar_Principal_Row';

export interface Sidebar_Principal_SubmenuCuartoNivelProps {
    state_transition: TransitionStatus,
    datos_usuario: UserData
}



const Sidebar_Principal_SubmenuCuartoNivel = (props: Sidebar_Principal_SubmenuCuartoNivelProps) => {
    const { valoressubMenuCuartoNivel, subMenuCuartoNivel, setsubMenuCuartoNivel, titulo_opcion_padre, titulo_opcion_CuartoNivel, icono_opcion_padre, subMenuDatosPersonales, subMenuNieto } = useSideBarContext()
    const component_arrow_left_header = <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" />
    </svg>

    let history = useHistory();
    const function_choice_animation_style = () => {

        const componente_salio = props.state_transition === "exited" || props.state_transition === "unmounted" || props.state_transition === "exiting"
        const timing = ".3s"

        if (props.state_transition === "entering" && subMenuCuartoNivel) {
            return {
                animation: `moveSubContainer ${timing} forwards`
            }
        }
        else if (props.state_transition === "entered") {
            return {
                transform: "translateX(0px)"
            }
        }
        else if (componente_salio && subMenuNieto && !subMenuCuartoNivel) {
            return {
                animation: `moveSubContainer ${timing} reverse forwards`
            }
        }

    }

    function handleClickOpcion(opciones: opcionesSideBar, redirect = false) {
        if (opciones.link) history.push(opciones.link);
    }



    function condicion_mostrar_opciones_nieto(opcion: opcionesSideBar, isplanifvacactivated: boolean, tipo_director_unidad: string, datos_usuario: UserData, titulo_opcion_padre: string) {
        const titulo_opcion_firmar_certificados = "Firmar Certificados";
        const titulo_opcion_admin_solic_certificados = "Emisión Certificados";
        const tiulo_planificacion_docente = "Planificación del personal docente";
        const titulo_opcion_cuenta_bancaria = "Registro / Actualización de Cuenta Bancaria";
        const titulo_opcion_decimos = "Acumulación / Mensualización Décimos";
        const titulo_opcion_gastos_personales = "Formulario Gastos Personales";
        const titulo_registro_marcaciones = "Registro de marcaciones";
        const titulo_notificacion_embarazo = "Notificación de embarazo";
        const titulo_cambio_horario_RN = "Solicitud de cambio de horario de permiso para cuidado del recién nacido";
        const titulo_opcion_firmar_accion = "Firmar Acción de Personal";
        const titulo_opcion_firmar_aprobaciones = "Elaboración de AP / Validación de Permisos";
        const titulo_opcion_revisar_aprobaciones = "Revisión de AP";
        const titulo_opcion_registrar_aprobaciones = "Registro y Control de AP";
        const titulo_opcion_notificar_aprobaciones = "Notificar Accion de Personal";
        const titulo_opcion_firmar_notificacion = "Notificación Embarazo";
        const titulo_opcion_firmar_accion_vacaciones = "Firmar AP de Vacaciones";
        const titulo_opcion_firmar_aprobaciones_vacaciones = "Elaboración de AP de Vacaciones / Validación de Permisos";
        const titulo_opcion_revisar_aprobaciones_vacaciones = "Revisión de AP de Vacaciones";
        const titulo_opcion_registrar_aprobaciones_vacaciones = "Registro y Control de AP de Vacaciones";
        const titulo_opcion_notificar_aprobaciones_vacaciones = "Notificar AP de Vacaciones";
        const titulo_firma_documento_pago = "Firma Documento Pago";
        const titulo_opcion_historial_marcaciones = "Aprobación Solicitud Marcación";
        const titulo_opcion_solicitud_pago_horas_extras = "Solicitud de Pago de Horas Extras";
        const titulo_opcion_aprobacion_pago_horas_extras = "Aprobación Solicitudes Horas Extras";
        const titulo_opcion_planificacion_pago_horas_extras = "Planificación Horas Extras";
        const PERSONALDOCENTE = "PD";
        const PERSONALADMINISTRATIVO = "PA";

        var resultado: JSX.Element = (
            <div className="submenuOpcionesHeaderNieto  ">
                <div className="container_icono_Principal_Content">
                    {/* {props.icon_opcion_padre?props.icon_opcion_padre():""} */}
                </div>
                {
                    <span onClick={() => handleClickOpcion(opcion)}>
                        {opcion.tituloStyled}
                    </span>
                }
                {
                    opcion.tituloStyled === undefined &&
                    <div className=" texto_submenuOpcionesHeaderNieto" onClick={() => handleClickOpcion(opcion)}>
                        {opcion.titulo}
                    </div>
                }

            </div>
        )

        var resultadoRedirect: JSX.Element = (
            <div className="submenuOpcionesHeaderNieto  ">
                <div className="container_icono_Principal_Content">
                    {/* {props.icon_opcion_padre?props.icon_opcion_padre():""} */}
                </div>
                {
                    <span onClick={() => handleClickOpcion(opcion)}>
                        {opcion.tituloStyled}
                    </span>
                }
                {
                    opcion.tituloStyled === undefined &&
                    <a className=" texto_submenuOpcionesHeaderNieto" href={opcion.link} target="_blank">
                        {opcion.titulo}
                    </a>
                }
            </div>
        )

        if (opcion.titulo === titulo_opcion_solicitud_pago_horas_extras) {
            return resultadoRedirect
        }
        else if (opcion.titulo === titulo_opcion_aprobacion_pago_horas_extras) {
            return resultadoRedirect
        }
        else if (opcion.titulo === titulo_opcion_planificacion_pago_horas_extras) {
            return resultadoRedirect
        }
        else if (opcion.titulo === titulo_registro_marcaciones) {
            { return resultadoRedirect };
        }
        else if (opcion.titulo === titulo_opcion_historial_marcaciones) {
            { return resultadoRedirect };
        }
        if (IsOpcionDesvinculacionUsuario(opcion.titulo) && opcion.rol_usuario === "USUARIO") {
            if (EstadosDesvinculacionValidation(opcion.titulo, datos_usuario.estadosDesvinculacion)) { return resultadoRedirect };
        }
        else if (IsOpcionDesvinculacionDirectivo(opcion.titulo) && titulo_opcion_padre === "DIRECTIVO DE UNIDAD") {
            return resultadoRedirect
        }
        else if (opcion.titulo === OPCION_TITULO_PLANIFICACION_VACACIONES) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_USUARIO) {
                if (isplanifvacactivated) return resultado

            }
            else {
                return resultado
            }

        }
        else if (opcion.titulo === titulo_registro_marcaciones) {
            if (expresion_adm(datos_usuario.regimen_usuario) && datos_usuario.roles_usuario.includes(ROL_DIRECTIVO_UNIDAD))
                return resultado
        }
        else if (opcion.titulo === titulo_opcion_firmar_certificados) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_DIRECTOR_TALENTOHUMANO) {

                var indice_respuesta: number = datos_usuario.roles_usuario.findIndex((value, index) => {
                    return value == ROL_DIRECTOR_TALENTOHUMANO
                })

                if (indice_respuesta != -1) {
                    return resultado
                }
            }
            else {
                return resultado
            }

        }
        else if (opcion.titulo === titulo_opcion_firmar_aprobaciones) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_ANALISTA_TH_AP && !datos_usuario.roles_usuario.includes(ROL_DIRECTOR_TALENTOHUMANO)) {

                var indice_respuesta: number = datos_usuario.roles_usuario.findIndex((value, index) => {
                    return value == ROL_ANALISTA_TH_AP
                })

                if (indice_respuesta != -1) {
                    return resultado
                }
            }

        }
        else if (opcion.titulo === titulo_opcion_firmar_aprobaciones_vacaciones) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_ANALISTA_TH_AP && !datos_usuario.roles_usuario.includes(ROL_DIRECTOR_TALENTOHUMANO)) {
                var indice_respuesta: number = datos_usuario.roles_usuario.findIndex((value, index) => {
                    return value == ROL_ANALISTA_TH_AP
                })
                if (indice_respuesta != -1) {
                    return resultado
                }
            }
        }
        else if (opcion.titulo === titulo_opcion_revisar_aprobaciones) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_ANALISTA_TH_AP && !datos_usuario.roles_usuario.includes(ROL_DIRECTOR_TALENTOHUMANO)) {

                var indice_respuesta: number = datos_usuario.roles_usuario.findIndex((value, index) => {
                    return value == ROL_ANALISTA_TH_AP
                })

                if (indice_respuesta != -1) {
                    return resultado
                }
            }

        }
        else if (opcion.titulo === titulo_opcion_revisar_aprobaciones_vacaciones) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_ANALISTA_TH_AP && !datos_usuario.roles_usuario.includes(ROL_DIRECTOR_TALENTOHUMANO)) {
                var indice_respuesta: number = datos_usuario.roles_usuario.findIndex((value, index) => {
                    return value == ROL_ANALISTA_TH_AP
                })
                if (indice_respuesta != -1) {
                    return resultado
                }
            }
        }
        else if (opcion.titulo === titulo_opcion_registrar_aprobaciones) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_ANALISTA_TH_AP && !datos_usuario.roles_usuario.find((roles) => roles === ROL_DIRECTOR_TALENTOHUMANO)) {

                var indice_respuesta: number = datos_usuario.roles_usuario.findIndex((value, index) => {
                    return value == ROL_ANALISTA_TH_AP
                })

                if (indice_respuesta != -1) {
                    return resultado
                }
            }

        }
        else if (opcion.titulo === titulo_opcion_registrar_aprobaciones_vacaciones) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_ANALISTA_TH_AP && !datos_usuario.roles_usuario.find((roles) => roles === ROL_DIRECTOR_TALENTOHUMANO)) {
                var indice_respuesta: number = datos_usuario.roles_usuario.findIndex((value, index) => {
                    return value == ROL_ANALISTA_TH_AP
                })
                if (indice_respuesta != -1) {
                    return resultado
                }
            }
        }
        else if (opcion.titulo === titulo_opcion_firmar_notificacion) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_ANALISTA_TH_AP) {

                var indice_respuesta: number = datos_usuario.roles_usuario.findIndex((value, index) => {
                    return value == ROL_ANALISTA_TH_AP
                })

                if (indice_respuesta != -1) {
                    return resultado
                }
            }

        }
        else if (opcion.titulo === OPCION_TITULO_MODIFICACION_PRESUPUESTO) {
            if (datos_usuario.roles_usuario.includes(ROL_ENCARGADO_GPE) || datos_usuario.roles_usuario.includes(ROL_ANALISTA_GPE)) {
                return resultado
            }
        }
        //else if (opcion.titulo === OPCION_TITULO_HISTORIAL_MOD_PRESUPUESTO) {
        //    if (datos_usuario.roles_usuario.includes(ROL_ENCARGADO_GPE) || datos_usuario.roles_usuario.includes(ROL_ANALISTA_GPE)) {
        //        return resultado
        //    }
        //} 
        else if (opcion.titulo === OPCION_TITULO_ASIGNACION_PRESUPUESTO) {
            if (datos_usuario.roles_usuario.includes(ROL_ENCARGADO_GPE) || datos_usuario.roles_usuario.includes(ROL_ANALISTA_GPE)) {
                return resultado
            }
        }
        else if (opcion.titulo === titulo_firma_documento_pago) {
            if (datos_usuario.roles_usuario.includes(ROL_FIRMA_HORAS_EXTRAS)) {
                return resultado
            }
        }
        else if (opcion.titulo === OPCION_TITULO_FIRMA_DOC_PAGO_HE) {
            if (opcion.rol_usuario && datos_usuario.roles_usuario.find((roles) => roles === opcion.rol_usuario) ) {
                return resultado
            }
        }
        else if (opcion.titulo === titulo_opcion_firmar_accion) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_NOMINA_TH && datos_usuario.roles_usuario.find((roles) => roles === ROL_NOMINA_TH)) {
                return resultado
            }
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_DIRECTOR_TALENTOHUMANO && datos_usuario.roles_usuario.find((roles) => roles === ROL_DIRECTOR_TALENTOHUMANO)) {
                return resultado
            }
        }
        else if (opcion.titulo === titulo_opcion_firmar_accion_vacaciones) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_NOMINA_TH && datos_usuario.roles_usuario.find((roles) => roles === ROL_NOMINA_TH)) {
                return resultado
            }
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_DIRECTOR_TALENTOHUMANO && datos_usuario.roles_usuario.find((roles) => roles === ROL_DIRECTOR_TALENTOHUMANO)) {
                return resultado
            }
        }
        else if (opcion.titulo === titulo_opcion_admin_solic_certificados) {
            if (!datos_usuario.roles_usuario.find((roles) => roles === ROL_DIRECTOR_TALENTOHUMANO)) {
                return resultado
            }
        }
        else if (opcion.titulo === titulo_opcion_notificar_aprobaciones) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_DIRECTOR_TALENTOHUMANO && datos_usuario.roles_usuario.find((roles) => roles === ROL_DIRECTOR_TALENTOHUMANO)) {
                return resultado
            }
        }
        else if (opcion.titulo === titulo_opcion_notificar_aprobaciones_vacaciones) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_DIRECTOR_TALENTOHUMANO && datos_usuario.roles_usuario.find((roles) => roles === ROL_DIRECTOR_TALENTOHUMANO)) {
                return resultado
            }
        }
        else if (opcion.titulo === titulo_opcion_decimos || opcion.titulo === titulo_opcion_gastos_personales) {
            if (opcion.rol_usuario && opcion.rol_usuario === ROL_DIRECTOR_TALENTOHUMANO && datos_usuario.roles_usuario.find((roles) => roles === ROL_DIRECTOR_TALENTOHUMANO)) {
                return resultado
            }
        }
        else if (opcion.titulo === titulo_opcion_cuenta_bancaria) {
            if (!datos_usuario.soloTieneContratoESPOLTECH) {
                return resultado
            }
        } else if (opcion.titulo === titulo_notificacion_embarazo) {
            if (datos_usuario.genero == "F") {
                return resultado
            }
        } else if (opcion.titulo === titulo_cambio_horario_RN) {
            if (datos_usuario.genero == "F") {
                return resultado
            }
        }
        else {
            return resultado
        }

    }

    //Datos del usuario que se necesita
    const { periodo_planificacion_vac_activo, roles, tipo_director_unidad } = props.datos_usuario
    return (
        <div className={"sideNavPrincipalNieto"} style={function_choice_animation_style()}>
            <div className="submenuHeader" onClick={() => setsubMenuCuartoNivel(false)}>

                <div>
                    {Icono_Flecha_Regreso}
                </div>
                <div className="container_icono_padre_submenu">
                    {icono_opcion_padre}
                </div>
                <div>
                    {titulo_opcion_padre}
                </div>
            </div>
            <div className="container_titulo_submenuNieto">{titulo_opcion_CuartoNivel}</div>
            {valoressubMenuCuartoNivel.map((opciones, index) => {
                return (
                    <React.Fragment key={index}>

                        {!opciones.tipo.rows ?
                            condicion_mostrar_opciones_nieto(opciones, periodo_planificacion_vac_activo, tipo_director_unidad, props.datos_usuario, titulo_opcion_padre)
                            :
                            <Sidebar_Principal_Row titulo_opcion_padre={opciones.titulo} subopciones={opciones} isChild={false} isSubNieto={true} />
                        }
                    </React.Fragment>
                )
            })}
        </div>
    )
}
export default Sidebar_Principal_SubmenuCuartoNivel;
